import React from "react";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn, FaMapMarkerAlt, FaPinterestP } from "react-icons/fa";
import { SiCodeforces, SiLeetcode } from "react-icons/si";
import Stats from "./Home/Stats";

const linkGroups = [
  {
    id: "code",
    label: "Code",
    links: [
      {
        href: "https://github.com/DevilsN3st",
        label: "GitHub",
        icon: <AiFillGithub />,
        external: true,
      },
      {
        href: "https://codeforces.com/profile/Devils_Nest",
        label: "Codeforces",
        icon: <SiCodeforces />,
        external: true,
      },
      {
        href: "https://leetcode.com/u/hgharshop/",
        label: "LeetCode",
        icon: <SiLeetcode />,
        external: true,
      },
    ],
  },
  {
    id: "social",
    label: "Social",
    links: [
      {
        href: "https://www.linkedin.com/in/hg-harsh-gupta/",
        label: "LinkedIn",
        icon: <FaLinkedinIn />,
        external: true,
      },
      {
        href: "https://twitter.com/harshgupta_hg",
        label: "Twitter",
        icon: <AiOutlineTwitter />,
        external: true,
      },
      {
        href: "https://www.instagram.com/harsh.gupta.sh/",
        label: "Instagram",
        icon: <AiFillInstagram />,
        external: true,
      },
      {
        href: "https://in.pinterest.com/hgharshgupta1234545hg/_pins/",
        label: "Pinterest",
        icon: <FaPinterestP />,
        external: true,
      },
    ],
  },
  {
    id: "contact",
    label: "Contact",
    links: [
      {
        href: "mailto:hgharshop@gmail.com",
        label: "Email",
        icon: <AiOutlineMail />,
        external: false,
      },
    ],
  },
];

function LinkGroup({ label, links }) {
  return (
    <div className="site-sidebar-group">
      <p className="site-sidebar-section-label">{label}</p>
      <ul className="site-sidebar-socials">
        {links.map((item) => (
          <li key={item.label}>
            <a
              href={item.href}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noreferrer" : undefined}
              className="site-sidebar-social-link"
            >
              <span className="site-sidebar-social-icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="site-sidebar-social-label">{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Sidebar() {
  return (
    <aside className="site-sidebar" aria-label="Profile">
      <div className="site-sidebar-inner">
        <header className="site-sidebar-identity">
          <h2 className="site-sidebar-name">Harsh Gupta</h2>
          <p className="site-sidebar-role">Software Engineer</p>
          <p className="site-sidebar-location">
            <FaMapMarkerAlt aria-hidden="true" />
            <span>Bengaluru, India</span>
          </p>
        </header>

        <Stats />

        <nav className="site-sidebar-links" aria-label="Profiles and contact">
          {linkGroups.map((group) => (
            <LinkGroup key={group.id} label={group.label} links={group.links} />
          ))}
        </nav>
      </div>
    </aside>
  );
}

export default Sidebar;
